exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-tooltip{\n    width: 300px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/request/request-form/request-form.component.css
// module id = ../../../../../src/app/modules/request/request-form/request-form.component.css
// module chunks = main